import EdTable from './src/EdTable.vue';

/* istanbul ignore next */
EdTable.install = function (Vue) {
  Vue.component(EdTable.name, EdTable)
}

export default EdTable;
